// PWA install-funnel event names. These MUST stay in lockstep with the server
// whitelist (tva-api constants/pwaAnalytics.js PWA_ANALYTICS_EVENTS) — an event
// not in that enum is rejected with 422. Only the install-funnel events are
// emitted from tva-whitelabel today; the service-worker diagnostic and push
// events also exist in the server enum but are emitted elsewhere/later.

export const PWA_MANIFEST_REQUESTED = "pwa_manifest_requested";
export const PWA_INSTALL_MODAL_SHOWN = "pwa_install_modal_shown";
export const PWA_INSTALL_CTA_CLICKED = "pwa_install_cta_clicked";
export const PWA_NATIVE_PROMPT_AVAILABLE = "pwa_native_prompt_available";
export const PWA_NATIVE_PROMPT_ACCEPTED = "pwa_native_prompt_accepted";
export const PWA_NATIVE_PROMPT_DISMISSED = "pwa_native_prompt_dismissed";
export const PWA_IOS_INSTRUCTIONS_SHOWN = "pwa_ios_instructions_shown";
export const PWA_INSTALLED = "pwa_installed";
export const PWA_STANDALONE_LAUNCH = "pwa_standalone_launch";
export const PWA_REPEAT_STANDALONE_LAUNCH = "pwa_repeat_standalone_launch";

// Phase 3 — service-worker lifecycle diagnostics. Emitted from the SW registration
// flow (swRegistrationCore callbacks → pwaSwDiagnostics), not the install funnel.
export const PWA_SW_REGISTERED = "pwa_sw_registered";
export const PWA_SW_REGISTRATION_FAILED = "pwa_sw_registration_failed";
export const PWA_SW_UPDATE_FOUND = "pwa_sw_update_found";
export const PWA_SW_ACTIVATED = "pwa_sw_activated";
export const PWA_CACHE_VERSION_ACTIVE = "pwa_cache_version_active";

// `source` dimension values (server enum PWA_ANALYTICS_SOURCES). Identifies which
// surface produced a funnel event; out-of-set values are clamped to "unknown"
// server-side.
export const PWA_SOURCE_AUTO_MODAL = "auto-modal";
export const PWA_SOURCE_NATIVE_PROMPT = "native-prompt";
export const PWA_SOURCE_IOS_GUIDE = "ios-guide";
export const PWA_SOURCE_HEADER = "header";
